import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

/**
 * Primary UI component for user interaction
 */
export const Text = ({
  children,
  link = null,
  subtitle = false,
  body1m = false,
  body = false,
  body2 = false,
  caption = false,
  overline = false,
  step = false,
  nav = false,
  button = false,
  newTab = false,
  classes = null,
  onClick = null,
  ...props
}) => {
  const target = newTab ? '_blank' : '_self';
  if(nav) return (
    <a href={link} onClick={onClick} target={target} rel={target === '_blank' ? 'noopener' : ''} className={[
      nav && 'nav',
      body1m && 'body1m',
      window.location.pathname === link && 'active',
      classes && classes,
    ].join(' ')}>
      {children}
    </a>
  );

  // Check if children contains React elements (not just strings)
  const hasReactElements = React.Children.toArray(children).some(
    child => React.isValidElement(child)
  );

  // Use span instead of p if children contains React elements to avoid nested p tags
  const Tag = hasReactElements ? 'span' : 'p';

  return (
    <Tag className={[
      body && 'body',
      subtitle && 'subtitle',
      body1m && 'body1m',
      body2 && 'body2',
      caption && 'caption',
      overline && 'lwd-overline',
      step && 'step',
      nav && 'nav',
      button && 'button',
      classes && classes,
    ].join(' ')}>
      {children}
    </Tag>
  );
}

Text.propTypes = {

  /**
   * Text of heading
   */
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  /**
   * is this a subtitle?
   */
  subtitle: PropTypes.bool,

  /**
   * is this a body1m?
   */
  body1m: PropTypes.bool,

  /**
   * is this a body?
   */
  body: PropTypes.bool,

  /**
   * is this a body2?
   */
  body2: PropTypes.bool,

  /**
   * is this a caption?
   */
  caption: PropTypes.bool,

  /**
   * is this a overline?
   */
  overline: PropTypes.bool,

  /**
   * is this a nav?
   */
  nav: PropTypes.bool,

  /**
   * add link for the nav
   */
  link: PropTypes.string,

  /**
   * is this a button?
   */
   button: PropTypes.bool,

  /**
   * open link in a new tab?
   */
   newTab: PropTypes.bool,

  /**
   * add classes
   */
  classes: PropTypes.string,
};

